<template>
  <div class="position-relative slides slop">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <hooper-container
          class="slides-container"
          style="height: auto"
          ref="carousel"
          :wheelControl="false"
          infiniteScroll
          @slide="updateCarousel"
        >
          <hooper-slide
            class="item relative"
            v-for="(
              { img_desktop, img_mobile, link, link_text, target }, keySlide
            ) in items"
            :key="keySlide"
          >
            <img
              :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
              class="d-block item-img"
              width="100%"
            />
            <div class="item-content" v-if="link && link_text">
              <v-container
                class="d-flex align-end pb-16 justify-center justify-sm-end"
              >
                <v-btn
                  class="text-none rounded-0"
                  height="48px"
                  color="secondary"
                  depressed
                  :target="target ? '_blank' : '_self'"
                  :href="link"
                >
                  <span class="text-body-1 text-sm-h6 primary--text">
                    {{ link_text }}
                  </span>
                  <v-icon color="primary" class="ml-2"
                    >fas fa-long-arrow-alt-right</v-icon
                  >
                </v-btn>
              </v-container>
            </div>
          </hooper-slide>
        </hooper-container>

        <div
          class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
        >
          <a
            class="
              d-flex
              align-center
              justify-center
              elevation-2
              pr-1
              slides-nav-item
            "
            @click.prevent="slidePrev"
          >
            <v-icon color="primary" :size="xs ? 20 : 30">
              fa-angle-left
            </v-icon>
          </a>
          <a
            class="
              d-flex
              align-center
              justify-center
              elevation-2
              pl-1
              slides-nav-item
            "
            @click.prevent="slideNext"
          >
            <v-icon color="primary" :size="xs ? 20 : 30">
              fa-angle-right
            </v-icon>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "slides",
};

export default {
  data: () => ({
    loading: true,
    carouselData: 0,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.slides {
  margin-top: -1px;
  aspect-ratio: 1920 / 680;

  @media screen and (max-width: 960px) {
    aspect-ratio: 600 / 600;
  }

  .item {
    &-content {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }
    &-img {
      aspect-ratio: 1920 / 680;
      object-fit: cover;
      -o-object-fit: cover;

      @media screen and (max-width: 960px) {
        aspect-ratio: 600 / 600;
      }
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 960px) {
      margin-top: -20px;
    }

    &-item {
      background-color: #ffffff;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      @media screen and (max-width: 960px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
.slides-container {
  ul,
  ol {
    padding: 0 !important;
  }
}
</style>
